import { useGlobalDataStore } from '@stores/globalData/globalData.store'

import type { ParsedQuery } from 'query-string'
import type { NavigateFunction } from 'react-router-dom'

/**
 * If we've remove all the query params, go to the given URL
 * @param url
 * @return `true` if we should continue without redirecting, otherwise `false`
 */
export const emptyParamsRedirectTo =
  (url: string) =>
  (urlParams: ParsedQuery, navigate: NavigateFunction): boolean => {
    if (!Object.keys(urlParams).length) {
      navigate(url, { replace: false })
      return false
    }
    return true
  }

/**
 * Returns the path to the given asset URI
 */
export const asset = (uri: string): string => {
  const { assetManifest, serverData } = useGlobalDataStore.getState()

  const assetPath = serverData ? serverData['assetPath'] : 'https://localhost:8080'
  let assetUri = uri
  if (assetManifest && assetManifest[uri]) {
    assetUri = assetManifest[uri]
  }

  return `${assetPath}/client/${assetUri}`
}
